import _toArray from "@babel/runtime/helpers/toArray";
import { determineDeclension as declension } from '@beef/utils';
import { isOldNotificationAPI } from "./types";
export var getNotificationsPreview = function getNotificationsPreview(notifications) {
  if (!notifications || notifications.length === 0) {
    return null;
  }
  var _notifications = _toArray(notifications),
    firstNotification = _notifications[0],
    rest = _notifications.slice(1);
  return rest.length ? {
    text: "\u0423 \u0432\u0430\u0441 ".concat(notifications.length, " ").concat(declension(['уведомление', 'уведомления', 'уведомлений'], notifications.length)),
    buttonText: 'Посмотреть всё',
    variant: 'primary',
    redirectToNavigation: true
  } : firstNotification;
};
export var filterRemovedNotification = function filterRemovedNotification(_ref) {
  var type = _ref.type,
    notifications = _ref.notifications;
  if (!type || !notifications || notifications.length === 0) {
    return null;
  }
  return notifications.filter(function (notification) {
    return notification.type !== type;
  });
};
export var mapNotification = function mapNotification(notification) {
  if (isOldNotificationAPI(notification)) {
    var _notification$action, _notification$action2, _notification$action3, _notification$action4;
    return {
      text: notification.text,
      buttonText: notification === null || notification === void 0 || (_notification$action = notification.action) === null || _notification$action === void 0 ? void 0 : _notification$action.buttonLabel,
      href: (notification === null || notification === void 0 || (_notification$action2 = notification.action) === null || _notification$action2 === void 0 ? void 0 : _notification$action2.type) === 'Link' ? notification === null || notification === void 0 || (_notification$action3 = notification.action) === null || _notification$action3 === void 0 ? void 0 : _notification$action3.link : undefined,
      type: notification === null || notification === void 0 || (_notification$action4 = notification.action) === null || _notification$action4 === void 0 ? void 0 : _notification$action4.type,
      variant: notification.style === 'Black' ? 'primary' : 'secondary'
    };
  }
  return {
    text: notification.text,
    buttonText: notification === null || notification === void 0 ? void 0 : notification.buttonLabel,
    href: notification === null || notification === void 0 ? void 0 : notification.link,
    type: notification === null || notification === void 0 ? void 0 : notification.type,
    variant: notification.style === 'Black' ? 'primary' : 'secondary'
  };
};